const modales = {
    "datosContacto": false,
    "errorConsultorioOsde": false,
    "informarProveedor": false,
    "successProveedor": false,
    "errorProveedor": false,
    "errorExterno": false,
    "errorExternoConectados": false,
    "confirmacionEnvio": false,
    "successPost": false,
    "errorPost": false,
    "exit": false,
    "consultorioConnectionBlocked": false,
};

export { modales };